export default __webpack_public_path__ + "static/media/img3.656f598c.png";